import { createTheme } from '@mui/material/styles'

// Color palette from Color Story
const colors = {
    paleSage: '#a0b485',
    lightPistachio: '#a6cc91',
    persianGreen: '#05967a',
    darkOlive: '#6a8143',
    arylideYellow: '#f4d970',
    oldGold: '#d7bb1e',
    tanBrown: '#e6b46d',
    earthYellow: '#ebaf5f',
    softBlue: '#7aadd9',
    cornflowerBlue: '#89bae4',
    lightCoralRed: '#e45c49',
    outrageousOrange: '#fa6a42',
    sonicSilver: '#717677',
    paleSilver: '#cdd6d1',
    eerieBlack: '#121212',
    raisinBlack: '#2a2a2a',
    culturedWhite: '#F0F0F0',
    antiFlashWhite: '#f2f3f4',
}

// Create the theme
const theme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: colors.persianGreen,
            light: colors.lightPistachio,
            dark: colors.darkOlive,
            contrastText: colors.culturedWhite,
        },
        secondary: {
            main: colors.softBlue,
            light: colors.cornflowerBlue,
            dark: colors.sonicSilver,
            contrastText: colors.eerieBlack,
        },
        error: {
            main: colors.lightCoralRed,
            light: colors.outrageousOrange,
            dark: colors.lightCoralRed,
            contrastText: colors.culturedWhite,
        },
        warning: {
            main: colors.oldGold,
            light: colors.arylideYellow,
            dark: colors.earthYellow,
            contrastText: colors.eerieBlack,
        },
        info: {
            main: colors.softBlue,
            light: colors.cornflowerBlue,
            dark: colors.softBlue,
            contrastText: colors.culturedWhite,
        },
        success: {
            main: colors.persianGreen,
            light: colors.lightPistachio,
            dark: colors.darkOlive,
            contrastText: colors.culturedWhite,
        },
        background: {
            default: colors.antiFlashWhite,
            paper: colors.culturedWhite,
        },
        text: {
            primary: colors.eerieBlack,
            secondary: colors.raisinBlack,
            disabled: colors.sonicSilver,
        },
        divider: colors.paleSilver,
    },
    typography: {
        fontFamily: [
            '"Noto Sans"',
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
        ].join(','),
        h1: {
            fontFamily: '"Elms Sans", sans-serif',
            fontWeight: 500,
            fontSize: '48pt',
        },
        h2: {
            fontFamily: '"Noto Sans", sans-serif',
            fontWeight: 400,
            fontSize: '24pt',
        },
        h3: {
            fontFamily: '"Noto Sans", sans-serif',
            fontWeight: 400,
            fontSize: '18pt',
        },
        h4: {
            fontFamily: '"Noto Sans", sans-serif',
            fontWeight: 400,
        },
        h5: {
            fontFamily: '"Space Grotesk", sans-serif',
            fontWeight: 300,
            fontSize: '24pt',
        },
        body1: {
            fontFamily: '"Noto Sans", sans-serif',
            fontWeight: 400,
            fontSize: '12pt',
        },
        body2: {
            fontFamily: '"Noto Sans", sans-serif',
            fontWeight: 400,
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    textTransform: 'none',
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: 12,
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    borderRadius: 12,
                },
            },
        },
    },
})

export default theme
